import type { Component, Slots } from 'vue'

let newModalIds = 0

export type ModalComponent<P> = Component<P, any, any, any, any>

export interface BaseModal<P = any> {
  component: ModalComponent<P>
  attrs?: Record<string, any> // TODO: Find a way to typecheck props.
  eventListeners?: Record<string, Function | undefined>
  slots?: Slots
  id?: string
  type?: 'alert' | 'confirm'
}

export const modals = shallowRef<BaseModal[]>([])

// Adds a modal to the current window.
//
// NOTE: It's not possible to open several modals with the same id.
// An unique id is auto-generated unless one is provided.
export function addModal (
  { component, attrs, eventListeners, slots, type, id = `modal-${newModalIds++}` }: BaseModal,
  reStack = false,
) {
  if (!modals.value.some(modal => modal.id === id) || reStack) {
    modals.value = [...modals.value, { component, attrs, eventListeners, slots, id, type }]
  }
  return id
}

// Removes a modal from the current window.
export function removeModal ({ id }: Pick<BaseModal, 'id'>) {
  modals.value = modals.value.filter(modal => modal.id !== id)
}

// Merges new attrs onto an existing modal in place. Keeps the same component
// instance (Vue reuses by :key="modal.id"), so prop changes flow through
// without an unmount/remount flash.
export function updateModal (id: string, attrs: Record<string, any>) {
  modals.value = modals.value.map(modal =>
    modal.id === id
      ? { ...modal, attrs: { ...modal.attrs, ...attrs } }
      : modal,
  )
}

export function removeModals (type: 'alert' | 'confirm') {
  modals.value = modals.value.filter(modal => modal.type !== type)
}

// Closes all modals.
export function closeAllModals () {
  modals.value = []
}

export function isModalOpen (id: string) {
  return modals.value.some(modal => modal.id === id)
}
